import { useEffect, useRef } from "react";

export default function Home() {
  const textRef = useRef(null);

  useEffect(() => {
    // Lock scroll on home
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = ''; };
  }, []);

  useEffect(() => {
    let rafId;
    const start = performance.now();

    const animate = (now) => {
      const t = (now - start) / 1000;
      // Slow pulse between 0.35 and 1.0
      const opacity = 0.35 + 0.65 * (0.5 + 0.5 * Math.sin(t * 1.1));
      if (textRef.current) textRef.current.style.opacity = opacity;
      rafId = requestAnimationFrame(animate);
    };

    rafId = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(rafId);
  }, []);

  return (
    <div style={{ width: '100vw', height: '100vh', overflow: 'hidden', position: 'relative' }}>
      <div
        ref={textRef}
        style={{
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
          textAlign: 'center',
          mixBlendMode: 'difference',
          color: 'white',
          userSelect: 'none',
        }}
      >
        <h2 style={{ fontSize: '4vw', margin: 0 }}>
          Coming Soon
        </h2>
      </div>
    </div>
  );
}
